import { useFormContext } from 'react-hook-form';

import { FormBlock, StepProps } from '@/widgets/ServiceFormTemplate';

import { ConditionView, FormSelect, FormUploader, StepControlPanel, StepPreview } from '@/shared/ui';
import { FormTextArea } from '@/shared/ui/TextArea/FormTextArea';

import { Loader } from '@/shared/ui';

import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/api/queryKeys';

import { FileType } from '@/helpers/fileHelper';

import api from '@/api';

import { ResidenceDescriptionOfRequestSchema } from '../../model/types';

export const DescriptionOfRequest: React.FC<StepProps> = ({ next, prev, currentRequestId, onStepDraftSave }) => {
  const requestId = currentRequestId ?? '';
  const { control } = useFormContext<ResidenceDescriptionOfRequestSchema>();

  const { data: appealTypeEntities = [], isLoading: areAppealTypeEntitiesLoading } = useQuery({
    queryKey: queryKeys.ars.appealKinds(),
    queryFn: () => api.ars.dictionary.appealKinds(),
    select: (res) => res.data,
  });

  return (
    <ConditionView if={!areAppealTypeEntitiesLoading} else={<Loader centered />}>
      <FormBlock title="Опис звернення">
        <FormSelect
          label="Вид звернення"
          control={control}
          name="appealType"
          required
          options={
            appealTypeEntities?.map((appeal) => ({
              id: appeal.id,
              label: appeal.name,
            })) ?? []
          }
        />
        <FormTextArea
          label="Опишіть ваше звернення"
          name="appealMessage"
          control={control}
          required
          showCount
          minLength={100}
          maxLength={4000}
        />
      </FormBlock>
      <FormBlock title="Додаткові матеріали до звернення">
        <FormUploader
          name="appealAttachments"
          maxCount={10}
          maxFileSizeInMb={50}
          control={control}
          allowedFileTypes={[
            FileType.ANY_IMAGE,
            FileType.ANY_AUDIO,
            FileType.ANY_VIDEO,
            FileType.ANY_TEXT,
            FileType.PDF,
            FileType.DOC,
            FileType.DOCX,
            FileType.ODT,
            FileType.XLS,
            FileType.ODS,
            FileType.PPT,
            FileType.PPTX,
            FileType.ODP,
          ]}
          hintText="Дозволені зображення, аудіо, відео та текстові документи. Розмір файла - до 50МБ"
          request_id={requestId}
          label="Додайте файл"
          onSaveDraft={onStepDraftSave}
        />
      </FormBlock>
      <StepControlPanel prev={prev} next={next} />
    </ConditionView>
  );
};

export const DescriptionOfRequestPreview: React.FC = () => {
  const { getValues } = useFormContext<ResidenceDescriptionOfRequestSchema>();
  const { appealMessage, appealType, appealAttachments } = getValues();

  return (
    <StepPreview
      title="Опис звернення"
      data={[
        ['Вид звернення', appealType?.label],
        ['Опишіть ваше звернення', appealMessage],
        ['Прикріплені файли', appealAttachments && appealAttachments.map((file) => file.file_name).join(', ')],
      ]}
    />
  );
};
